import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    disabled;
    confidence;
    type;
    get rules() {
        return {
            smooth: [
                {
                    validator: (rule, value, callback) => {
                        let rep = /^([1-9]|[1-9]\d|100)$/;
                        if (!rep.test(value)) {
                            callback(new Error(`${this.$t('thresholdInputRule')}`));
                        }
                        else if (Number(value) <= Number(this.confidence.minor) || Number(value) <= Number(this.confidence.major)) {
                            callback(new Error(' '));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            minor: [
                {
                    validator: (rule, value, callback) => {
                        let rep = /^([1-9]|[1-9]\d|100)$/;
                        if (!rep.test(value)) {
                            callback(new Error(`${this.$t('thresholdInputRule')}`));
                        }
                        else if (Number(value) >= Number(this.confidence.smooth) || Number(value) <= Number(this.confidence.major)) {
                            callback(new Error(' '));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            major: [
                {
                    validator: (rule, value, callback) => {
                        let rep = /^([1-9]|[1-9]\d|100)$/;
                        if (!rep.test(value)) {
                            callback(new Error(`${this.$t('thresholdInputRule')}`));
                        }
                        else if (Number(value) >= Number(this.confidence.minor) || Number(value) >= Number(this.confidence.smooth)) {
                            callback(new Error(' '));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }
    onConfidence() {
        this.isValidate();
    }
    getPattern() {
        let newTime = /^([1-9]\d?|100)$/;
        switch (String(this.type)) {
            case 'vehicleNumber':
                newTime = /^([1-9]|[1-9]\d|[1-9]\d\d)$/;
                break;
            default:
                newTime = /^([1-9]\d?|100)$/;
        }
        return newTime;
    }
    // get inputPlaceholder() {}
    changeName(val) {
        this.$emit('update:confidence', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    getType() {
        let icon = '%';
        switch (String(this.type)) {
            case 'vehicleNumber':
                icon = '';
                break;
            default:
                icon = '%';
        }
        return icon;
    }
};
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop()
], default_1.prototype, "confidence", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Watch('confidence', { deep: true })
], default_1.prototype, "onConfidence", null);
default_1 = __decorate([
    Component({
        name: 'SingleConfidence',
        components: {},
        i18n: {
            messages: {
                zh: {
                    smooth: '畅通',
                    minor: '轻度拥堵',
                    major: '中度拥堵',
                    critical: '重度拥堵',
                    thresholdInputRule: '请输入匹配度阈值，1-100',
                    // thresholdInputRule: '请输入匹配度阈值，1-100',
                    smoothRule: '畅通必须大于中度和轻度',
                    minorRule: '轻度必须小于畅通且大于中度',
                    majorRule: '中度必须小于畅通和轻度',
                },
                en: {
                    smooth: 'Smooth',
                    minor: 'Minor',
                    major: 'Major',
                    critical: 'Critical',
                    thresholdInputRule: 'Please enter matching rate, 1-100',
                    smoothRule: 'patency must be greater than mild to moderate',
                    minorRule: 'Mild must be less than smooth and greater than moderate',
                    majorRule: 'Moderate must be less than smooth and mild',
                },
            },
        },
    })
], default_1);
export default default_1;
